import { Observable } from 'rxjs'
import { map, switchMap, take } from 'rxjs/operators'

import { Featured } from '@skinsoft/types'
import { userSelectors } from '@skinsoft/selectors'
import { UserDataStore } from '@skinsoft/entity'
import { HistoryRecord } from '@skinsoft/ui'


export function resolveAuthor(
    source$: Observable<Featured | HistoryRecord>,
): Observable<Featured | HistoryRecord> {
    const userDataStore = UserDataStore.getInstance();
    return source$.pipe(
        switchMap(featured => {
            if (!featured.author) {
                return source$;
            }

            return userDataStore.fetchOne(featured.author as string).pipe(
                take(1),
                map(user => ({
                    ...featured,
                    author: userSelectors.fullName(user),
                })),
            );
        }),
    );
}
